// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"99b4e1bb","506":"7ef9d20b","634":"84eefe35"}[chunkId] + ".chunk.js";
};